export const getPathExperience = (path: string) => {
  if (typeof window !== "undefined") {
    if (window.location.pathname.includes("experiencia")) {
      return `${path}-experiencia`
    } else {
      return path
    }
  } else {
    return path
  }
}

export const isFlowExperience = () => {
  if (typeof window !== "undefined") {
    return window.location.pathname.includes("experiencia")
  }
  return false
}
